// Shared TypeScript type definitions for the card game platform
// These types will be used across backend, frontend, and mobile clients
// Game-related types
export var GameVariant;
(function (GameVariant) {
    GameVariant["KADI_NI_TIDI"] = "kadi-ni-tidi";
    GameVariant["THREE_ZERO_FOUR"] = "304";
    GameVariant["TWENTY_EIGHT"] = "twenty-eight";
    GameVariant["MENDIKOT"] = "mendikot";
    GameVariant["DEHLA_PAKAD"] = "dehla-pakad";
    GameVariant["THREE_TWO_FIVE"] = "3-2-5";
    GameVariant["TWENTY_NINE"] = "twenty-nine";
    GameVariant["FORTY"] = "forty";
    GameVariant["COURT_PIECE"] = "court-piece";
    GameVariant["JUDGEMENT"] = "judgement";
    // International variants
    GameVariant["SWISS_JASS"] = "swiss-jass";
    GameVariant["BELOTE"] = "belote";
    GameVariant["SKAT"] = "skat";
    GameVariant["SPADES"] = "spades";
})(GameVariant || (GameVariant = {}));
export var Suit;
(function (Suit) {
    Suit["HEARTS"] = "hearts";
    Suit["DIAMONDS"] = "diamonds";
    Suit["CLUBS"] = "clubs";
    Suit["SPADES"] = "spades";
})(Suit || (Suit = {}));
export var Rank;
(function (Rank) {
    Rank["TWO"] = "2";
    Rank["THREE"] = "3";
    Rank["FOUR"] = "4";
    Rank["FIVE"] = "5";
    Rank["SIX"] = "6";
    Rank["SEVEN"] = "7";
    Rank["EIGHT"] = "8";
    Rank["NINE"] = "9";
    Rank["TEN"] = "10";
    Rank["JACK"] = "J";
    Rank["QUEEN"] = "Q";
    Rank["KING"] = "K";
    Rank["ACE"] = "A";
})(Rank || (Rank = {}));
export var GamePhase;
(function (GamePhase) {
    GamePhase["WAITING"] = "waiting";
    GamePhase["DEALING"] = "dealing";
    GamePhase["BIDDING"] = "bidding";
    GamePhase["TRUMP_SELECTION"] = "trump-selection";
    GamePhase["PARTNER_CALLING"] = "partner-calling";
    GamePhase["PLAYING"] = "playing";
    GamePhase["SCORING"] = "scoring";
    GamePhase["FINISHED"] = "finished";
})(GamePhase || (GamePhase = {}));
export var RoomStatus;
(function (RoomStatus) {
    RoomStatus["WAITING"] = "waiting";
    RoomStatus["IN_PROGRESS"] = "in-progress";
    RoomStatus["FINISHED"] = "finished";
    RoomStatus["CLOSED"] = "closed";
})(RoomStatus || (RoomStatus = {}));
export var TournamentFormat;
(function (TournamentFormat) {
    TournamentFormat["SINGLE_ELIMINATION"] = "single-elimination";
    TournamentFormat["DOUBLE_ELIMINATION"] = "double-elimination";
    TournamentFormat["ROUND_ROBIN"] = "round-robin";
    TournamentFormat["SWISS"] = "swiss";
})(TournamentFormat || (TournamentFormat = {}));
export var TournamentStatus;
(function (TournamentStatus) {
    TournamentStatus["REGISTRATION"] = "registration";
    TournamentStatus["IN_PROGRESS"] = "in-progress";
    TournamentStatus["FINISHED"] = "finished";
    TournamentStatus["CANCELLED"] = "cancelled";
})(TournamentStatus || (TournamentStatus = {}));
export var RoundStatus;
(function (RoundStatus) {
    RoundStatus["PENDING"] = "pending";
    RoundStatus["IN_PROGRESS"] = "in-progress";
    RoundStatus["COMPLETED"] = "completed";
})(RoundStatus || (RoundStatus = {}));
export var MatchStatus;
(function (MatchStatus) {
    MatchStatus["SCHEDULED"] = "scheduled";
    MatchStatus["IN_PROGRESS"] = "in-progress";
    MatchStatus["COMPLETED"] = "completed";
    MatchStatus["FORFEIT"] = "forfeit";
})(MatchStatus || (MatchStatus = {}));
export var AchievementCategory;
(function (AchievementCategory) {
    AchievementCategory["GAMES_PLAYED"] = "games-played";
    AchievementCategory["GAMES_WON"] = "games-won";
    AchievementCategory["STREAKS"] = "streaks";
    AchievementCategory["SPECIAL_PLAYS"] = "special-plays";
    AchievementCategory["CULTURAL"] = "cultural";
    AchievementCategory["SOCIAL"] = "social";
})(AchievementCategory || (AchievementCategory = {}));
export var RequirementType;
(function (RequirementType) {
    RequirementType["GAMES_PLAYED"] = "games-played";
    RequirementType["GAMES_WON"] = "games-won";
    RequirementType["CONSECUTIVE_WINS"] = "consecutive-wins";
    RequirementType["PERFECT_GAMES"] = "perfect-games";
    RequirementType["CULTURAL_GAMES"] = "cultural-games";
})(RequirementType || (RequirementType = {}));
export var RewardType;
(function (RewardType) {
    RewardType["EXPERIENCE"] = "experience";
    RewardType["COINS"] = "coins";
    RewardType["COSMETIC"] = "cosmetic";
    RewardType["TITLE"] = "title";
})(RewardType || (RewardType = {}));
export var MessageType;
(function (MessageType) {
    MessageType["TEXT"] = "text";
    MessageType["EMOJI"] = "emoji";
    MessageType["SYSTEM"] = "system";
    MessageType["GAME_ACTION"] = "game-action";
})(MessageType || (MessageType = {}));
export var PurchaseStatus;
(function (PurchaseStatus) {
    PurchaseStatus["PENDING"] = "pending";
    PurchaseStatus["COMPLETED"] = "completed";
    PurchaseStatus["FAILED"] = "failed";
    PurchaseStatus["REFUNDED"] = "refunded";
})(PurchaseStatus || (PurchaseStatus = {}));
export var ItemCategory;
(function (ItemCategory) {
    ItemCategory["CARD_BACKS"] = "card-backs";
    ItemCategory["TABLE_THEMES"] = "table-themes";
    ItemCategory["AVATARS"] = "avatars";
    ItemCategory["EMOTES"] = "emotes";
    ItemCategory["PREMIUM_FEATURES"] = "premium-features";
})(ItemCategory || (ItemCategory = {}));
export var ItemRarity;
(function (ItemRarity) {
    ItemRarity["COMMON"] = "common";
    ItemRarity["UNCOMMON"] = "uncommon";
    ItemRarity["RARE"] = "rare";
    ItemRarity["EPIC"] = "epic";
    ItemRarity["LEGENDARY"] = "legendary";
})(ItemRarity || (ItemRarity = {}));
// Localization types
export var Language;
(function (Language) {
    Language["ENGLISH"] = "en";
    Language["HINDI"] = "hi";
    Language["GUJARATI"] = "gu";
    Language["TAMIL"] = "ta";
    Language["BENGALI"] = "bn";
    Language["URDU"] = "ur";
    Language["MARATHI"] = "mr";
    Language["PUNJABI"] = "pa";
})(Language || (Language = {}));
// Theme types
export var Theme;
(function (Theme) {
    Theme["LIGHT"] = "light";
    Theme["DARK"] = "dark";
    Theme["TRADITIONAL_INDIAN"] = "traditional-indian";
    Theme["FESTIVAL"] = "festival";
    Theme["MODERN"] = "modern";
})(Theme || (Theme = {}));
export var RankTier;
(function (RankTier) {
    RankTier["BRONZE"] = "bronze";
    RankTier["SILVER"] = "silver";
    RankTier["GOLD"] = "gold";
    RankTier["PLATINUM"] = "platinum";
    RankTier["DIAMOND"] = "diamond";
    RankTier["MASTER"] = "master";
    RankTier["GRANDMASTER"] = "grandmaster";
})(RankTier || (RankTier = {}));
//# sourceMappingURL=index.js.map